import 'src/index.css';
import 'src/App.css';
import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { UIProvider, useUI } from 'src/context/UIContext';
import TopBar from 'src/components/TopBar';
import SiteFooter from 'src/components/SiteFooter';
import EngineerPage from 'src/pages/EngineerPage';
import BooksPage from 'src/pages/BooksPage';
import TBRPage from 'src/pages/TBRPage';
import PageTracker from 'src/components/analytics/PageTracker';

function AppShell() {
    const { theme } = useUI();
    const { pathname } = useLocation();

    // Derive aesthetic from route: /books → editorial, everything else → mono
    const aesthetic = pathname.startsWith('/books') ? 'editorial' : 'mono';

    // Apply body data attributes so CSS tokens flip
    useEffect(() => {
        document.body.dataset.aesthetic = aesthetic;
        document.body.dataset.theme = theme;
    }, [aesthetic, theme]);

    return (
        <div className="app-root">
            <PageTracker />
            <TopBar aesthetic={aesthetic} />
            <main className="page-content">
                <Routes>
                    <Route path="/" element={<EngineerPage />} />
                    <Route path="/books" element={<BooksPage />} />
                </Routes>
            </main>
            <SiteFooter />
        </div>
    );
}

export default function App() {
    return (
        <UIProvider>
            <Routes>
                <Route path="/jgirlsandmatbr" element={<TBRPage />} />
                <Route path="*" element={<AppShell />} />
            </Routes>
        </UIProvider>
    );
}
